import { ACADEMY_CATALOG_SERVICE_URI, BASE_URI_PROGRESS } from '../../constants/ApiConstants';
import { registerMutation, registerQuery, useMutation, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
import { useCallback, useMemo } from 'react';
import { GET_ALL_PROGRESS, GET_PLAYLIST_PROGRESS } from '../userProgress';
import Raven from 'raven-js';
export const SHORTS_API = `${ACADEMY_CATALOG_SERVICE_URI}/shorts/`;

// GET_SHORT is not necessary for now as GET_ALL_SHORTS retrieves the same data. Once
// we manage to load all content resources correctly without fetching all we will reactivate
// GET_SHORT

// const GET_SHORT = registerQuery({
//   fieldName: 'shorts',
//   args: ['shortId', 'language'],
//   fetcher: ({ shortId, language }: { shortId: number; language: string }) =>
//     http.get<Short>(`${SHORTS_API}${shortId}/${language}`),
// });

const GET_ALL_SHORTS = registerQuery({
  fieldName: 'shorts',
  args: ['language'],
  fetcher: ({
    language
  }) => http.get(`${SHORTS_API}${language}`)
});
export const useAllShorts = (language, skip) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ALL_SHORTS, {
    skip,
    variables: {
      language
    }
  });
  return {
    allShorts: data,
    allShortsLoading: loading,
    allShortsError: error
  };
};
export const useShort = (shortId, language, skip) => {
  const {
    allShorts,
    allShortsLoading,
    allShortsError
  } = useAllShorts(language, skip);
  const short = useMemo(() => allShorts && allShorts.find(s => s.contentId === shortId), [allShorts, shortId]);
  return {
    short,
    shortLoading: allShortsLoading,
    shortError: allShortsError
  };
};
const GET_SHORT_PROGRESS = registerQuery({
  fieldName: 'shortProgress',
  args: ['shortId'],
  fetcher({
    shortId
  }) {
    return http.get(`${BASE_URI_PROGRESS}/user-progress/short/${shortId}`);
  }
});
export const useShortProgress = (shortId, language, skip) => {
  const {
    data: lessonProgressById,
    loading: lessonProgressByIdLoading,
    error: lessonProgressByIdError
  } = useQuery(GET_SHORT_PROGRESS, {
    variables: {
      shortId
    },
    skip,
    fetchPolicy: 'cache-first'
  });
  return {
    lessonProgressById,
    lessonProgressByIdLoading,
    lessonProgressByIdError
  };
};
export const START_SHORT_PROGRESS = registerMutation({
  fieldName: 'startShortProgress',
  args: ['language', 'shortId', 'playlistId'],
  fetcher({
    language,
    shortId,
    playlistId
  }) {
    return http.post(`${BASE_URI_PROGRESS}/asset-progress/start/shorts/${shortId}`, {
      data: {
        playlistId,
        language
      }
    });
  }
});
export const useStartShort = (shortId, language, playlistId) => {
  const [mutate, {
    loading: startShortLoading,
    called: startShortCalled,
    error: startShortError,
    data: startShortData
  }] = useMutation(START_SHORT_PROGRESS);
  const startShort = useCallback(() => {
    return mutate({
      awaitRefetchQueries: true,
      variables: {
        shortId,
        language,
        playlistId
      },
      refetchQueries: [{
        query: GET_ALL_PROGRESS,
        variables: {
          language
        }
      }, {
        query: GET_SHORT_PROGRESS,
        variables: {
          shortId,
          language
        }
      }, ...(playlistId ? [{
        query: GET_PLAYLIST_PROGRESS,
        variables: {
          playlistId
        }
      }] : [])],
      onError(error) {
        Raven.captureException(error);
      }
    });
  }, [language, mutate, playlistId, shortId]);
  return [startShort, {
    startShortLoading,
    startShortCalled,
    startShortError,
    startShortData
  }];
};